export default __webpack_public_path__ + "static/media/teamcoffee.e7fd0478.svg";